export default "__VITE_PUBLIC_ASSET__bf8c55a5__"